<form [formGroup]="quoteForm" class="new-proposal__fields new-proposal__fields--quote">

	<h3 class="left" i18n="@@proposals.quote">Quote</h3>
	<div class="create-invoice revealed">
		<div class="create-invoice__wrap">
			<section class="create-invoice__content">
				<div class="invoice-detail">
					<header class="invoice-detail__header">
						<span class="invoice-detail__header--title" i18n="@@proposals.deliverables">Deliverables</span>
						<span class="invoice-detail__header--qty">
							<ng-container i18n="@@common.hrs" *ngIf="quoteForm.controls.project_type.value == 'hourly';else qtyLabel">Hrs </ng-container>
							<ng-template i18n="@@common.qty" #qtyLabel>Qty</ng-template>
						</span>
						<span class="invoice-detail__header--rate" i18n="@@proposals.rate">Rate</span>
						<span class="invoice-detail__header--cost" i18n="@@proposals.cost">Cost</span>
						<span class="invoice-detail__header--close"></span>
					</header>
					<div class="invoice-detail__content">
						<ul *ngIf="deliverables && deliverables.length">
							<li *ngFor="let deliverable of deliverables; index as i">
								<span class="invoice-detail__content--title">{{ deliverable.title }}</span>
								<span class="invoice-detail__content--qty">{{ deliverable.quantity }}</span>
								<span class="invoice-detail__content--rate">{{ deliverable.rate | myCurrency  }}</span>
								<span class="invoice-detail__content--cost">{{ deliverable.rate && deliverable.rate ? (deliverable.rate * deliverable.quantity | myCurrency ) : '0.00' }}</span>
								<span class="invoice-detail__content--close">
									<a href="javascript:void(0)" (click)="removeDeliverable(i)">
										<svg version="1.1" x="0px" y="0px" width="12" height="12" viewBox="0 0 14 14">
											<path fill="none" stroke-width="2" stroke-linecap="square" d="M2.8,11.2l8.5-8.5 M2.8,2.8l8.5,8.5" />
										</svg>
									</a>
								</span>
							</li>
						</ul>
						<form [formGroup]="deliverableForm" class="fieldgroup" (ngSubmit)="addDeliverable(deliverableForm)" id="create-deliverable">
							<span class="invoice-detail__content--title">
								<fieldset [ngClass]="{'has-error': isDeliverableSubmitted && deliverableForm.get('title').errors?.required}">
									<input #createForm type="text" name="title" formControlName="title" i18n-placeholder="@@proposals.type_here" placeholder="Type Here" autocomplete="off" />
									<span class="field-error" i18n="@@error.required">Required</span>
								</fieldset>
							</span>

							<span class="invoice-detail__content--qty">
								<fieldset [ngClass]="{'has-error': isDeliverableSubmitted && deliverableForm.get('quantity').invalid }">
									<input type="number" name="quantity" formControlName="quantity" placeholder="0" autocomplete="off" />
									<span class="field-error" *ngIf="isDeliverableSubmitted && deliverableForm.get('quantity').errors?.required" i18n="@@error.required">Required</span>
									<span class="field-error" *ngIf="isDeliverableSubmitted && deliverableForm.get('quantity').errors?.min" i18n="@@error.invalid_number">Invalid</span>
								</fieldset>
							</span>

							<span class="invoice-detail__content--rate">
								<fieldset [ngClass]="{'has-error': isDeliverableSubmitted && deliverableForm.get('rate').invalid }">
									<input type="number" name="rate" formControlName="rate" placeholder="{{ 0.00 | myCurrency }}" autocomplete="off" />
									<span class="field-error" *ngIf="isDeliverableSubmitted && deliverableForm.get('rate').errors?.required" i18n="@@error.required">Required</span>
									<span class="field-error" *ngIf="isDeliverableSubmitted && deliverableForm.get('rate').errors?.min" i18n="@@error.invalid_number">Invalid</span>
								</fieldset>
							</span>

							<span class="invoice-detail__content--cost edit-cost">
								{{ deliverableCost(deliverableForm.value) | myCurrency  }}
							</span>

							<span class="invoice-detail__content--add">
								<button class="tu-btn-circular pink m-p-0" type="submit">
									<svg width="14" height="14" viewBox="0 0 14 14">
										<g fill="none" fill-rule="evenodd" stroke="#FFF" stroke-linecap="square" stroke-width="2">
											<path d="M1 7h12M7 1v12" />
										</g>
									</svg>
								</button>
							</span>

						</form>

						<div class="invoice-detail__content--total">
							<div class="invoice-detail__content--total-item">
								<ng-container i18n="@@proposals.total_amount">Total Amount</ng-container>
								<span>{{ totalAmount | myCurrency  }}</span>
							</div>
							<div class="invoice-detail__content--total-item" *ngIf="quoteForm.get('tax_rate').value">
								<ng-container i18n="@@proposals.tax">VAT</ng-container> ({{ quoteForm.get('tax_rate').value }}%)
								<span>{{ (totalAmount * quoteForm.get('tax_rate').value)/100 | myCurrency  }}</span>
							</div>
							<div class="invoice-detail__content--total-item">
								<ng-container i18n="@@proposals.sub_total">Sub Total</ng-container>
								<span>{{ subTotal | myCurrency  }}</span>
							</div>
						</div>
					</div>
				</div>
				<div class="new-proposal__controlsBTN">
					<a href="javascript:void(0)" class="tu-btn transparent" (click)="triggerPrevious.emit(0)" i18n="@@button.back">Back</a>
					<a href="javascript:void(0)" class="tu-btn pink next_btn" (click)="submit()" i18n="@@button.next">Next</a>
					<a href="javascript:void(0)" class="tu-btn transparent" (click)="skipStep.emit(0)" i18n="@@button.skip">Skip</a>
				</div>
			</section>
			<aside class="create-invoice__side">

				<div class="sideRow">
					<fieldset [ngClass]="{'has-error': quoteSubmitted && quoteForm.get('proposal_number').errors }">
						<label i18n="@@proposals.quotation_number">Quotation Number #</label>
						<input type="number" class="project-title" formControlName="proposal_number" placeholder="Quotation number" i18n-placeholder="@@proposals.quotation_number" />
						<span class="field-error" i18n="@@error.serverError_proposal_number" *ngIf="quoteForm.controls.proposal_number.errors">
							{{ quoteForm.controls.proposal_number.errors?.serverError ? quoteForm.controls.proposal_number.errors?.serverError : '* Required' }}
						</span>
					</fieldset>
				</div>

				<div class="sideRow">
					<fieldset [ngClass]="{'has-error': quoteSubmitted && quoteForm.get('client_id').errors && quoteForm.get('client_id').errors.required}" class="inv-to">
						<label i18n="@@proposals.proposal_to"> Proposal to</label>
						<select app-select2 [options]="{
								ajax: {url: clientListApi},
								idColumn: 'id',
								textColumn: 'full_name'
							}" [selected]="selectedClient ? {id: selectedClient.id, text: selectedClient.full_name} : null" (itemSelected)="selectClient($event)" i18n-data-placeholder="@@option.select_client" data-placeholder="Please type client name" formControlName="client_id"><option></option></select>
						<span class="field-error" i18n="@@error.required">Required</span>
					</fieldset>
				</div>

				<div class="sideRow">
					<fieldset class="mb-0" [ngClass]="{'has-error': quoteSubmitted && quoteForm.controls.quote_date.errors?.required}">
						<label i18n="@@quotation.quotation_date">Quotation Date</label>
						<div class="date-input-wrap">
							<input type="text" date-dropper formControlName="quote_date" data-large-default="true" class="date-input datedropper-init" data-theme="teamup" data-dd-format="d/m/Y" id="quoteDate" />
						</div>
						<span class="field-error" i18n="@@error.required">* Required</span>
					</fieldset>
				</div>

				<div class="sideRow twoColumn">
					<div class="half-section">
						<input class="styled-checkbox" [formControl]="quoteForm.controls.include_tax" id="include-tax" type="checkbox" (change)="enableTax($event.target.checked)">
						<label for="include-tax" i18n="@@proposals.include_tax">Include VAT?</label>
					</div>
					<div class="half-section">
						<fieldset class="no-label mb-0" [ngClass]="{'has-error': quoteSubmitted && quoteForm.controls.tax_rate.errors && quoteForm.controls.tax_rate.errors.required}">
							<input type="number" id="include-tax-input" formControlName="tax_rate" [attr.disabled]="quoteForm.controls.include_tax.value ? null : 'disabled'" /> <span>%</span>
							<span class="field-error" i18n="@@error.required">* Required</span>
						</fieldset>
					</div>
				</div>

				<div class="sideRow">
					<fieldset class="mb-0" [ngClass]="{'has-error': quoteSubmitted && quoteForm.controls.project_type.errors && quoteForm.controls.project_type.errors.required}">
						<label i18n="@@proposals.project_type">Project Type</label>
						<select nice-select formControlName="project_type">
							<option *ngFor="let type of projectTypes" [ngValue]="type.value">{{type.label}}</option>
						</select>
						<span class="field-error" i18n="@@error.required">* Required</span>
					</fieldset>
				</div>

				<div class="create-invoice__invoiceTerms">
					<a href="javascript:void(0)" (click)="openAddPaymentInfoModal()" class="tu-btn transparent" i18n="@@proposals.payment_information">Payment Information</a>
				</div>

			</aside>
		</div>
	</div>

</form>